// extracted by mini-css-extract-plugin
export default {"checkbox":"makeRowsSelectable_checkbox__cTmEM","checked":"makeRowsSelectable_checked__3Lvt9"};